import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class ArticleComment extends BaseModel {
  static override constructorName = 'ArticleComment'

  id: number = 0
  text: string = ''
  user: string = ''
  'created_at': string = ''
  images: string[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['images'])

      if (Array.isArray(data.images)) {
        this.images = data.images.map(img => toCroppedImage(img))
      }
    }
  }
}

registerModel(ArticleComment)
